/* B2B e-invoice collection block (P1) — vanilla JS, no framework.
 * All DOM ids / classes prefixed b2b-. Calls the same-origin proxy only.
 * Zero impact on individual customers who never expand the block. */
(function () {
  'use strict';

  var B2B_API_BASE = 'https://product.stylo-ladefense.com';

  var root = document.getElementById('b2b-einvoice-root');
  if (!root) return;

  var toggle = document.getElementById('b2b-einvoice-toggle');
  var panel = document.getElementById('b2b-einvoice-panel');
  var toggleIcon = root.querySelector('.b2b-einvoice__toggle-icon');

  var sirenInput = document.getElementById('b2b-einvoice-siren');
  var sirenHint = document.getElementById('b2b-einvoice-siren-hint');
  var nameInput = document.getElementById('b2b-einvoice-name');
  var nameHint = document.getElementById('b2b-einvoice-name-hint');
  var resultsList = document.getElementById('b2b-einvoice-results');
  var tvaInput = document.getElementById('b2b-einvoice-tva');
  var tvaHint = document.getElementById('b2b-einvoice-tva-hint');
  var pdpStatus = document.getElementById('b2b-einvoice-pdp-status');

  var attrTva = document.getElementById('b2b-einvoice-attr-tva');
  var attrName = document.getElementById('b2b-einvoice-attr-name');
  var attrSiren = document.getElementById('b2b-einvoice-attr-siren');
  var attrRegistered = document.getElementById('b2b-einvoice-attr-registered');
  var attrEndpoint = document.getElementById('b2b-einvoice-attr-endpoint');

  var TVA_RE = /^FR[0-9A-Z]{2}[0-9]{9}$/;
  var SIREN_RE = /^[0-9]{9}$/;

  /* ---------- helpers ---------- */

  function setHint(el, msg, kind) {
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'b2b-einvoice__hint';
    if (kind) el.classList.add('b2b-einvoice__hint--' + kind);
  }

  function digitsOnly(s) {
    return (s || '').replace(/[^0-9]/g, '');
  }

  function fetchJson(url) {
    return fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'omit'
    }).then(function (resp) {
      if (!resp.ok) {
        var err = new Error('HTTP ' + resp.status);
        err.status = resp.status;
        throw err;
      }
      return resp.json();
    });
  }

  /* Persist the 5 attributes to the cart via /cart/update.js. Belt-and-suspenders
   * alongside the hidden <input name="attributes[...]"> inside #cartform: this is
   * an AJAX-cart theme (cart-form / data-ajax-update) where the checkout button
   * may be hijacked (no classic form POST), so we also write cart attributes
   * directly. Non-fatal on failure — hidden inputs still post on a classic submit. */
  function persistAttributes() {
    var payload = {
      attributes: {
        tva_number: attrTva.value || '',
        company_name: attrName.value || '',
        company_siren: attrSiren.value || '',
        einvoice_registered: attrRegistered.value || '',
        einvoice_endpoint: attrEndpoint.value || ''
      }
    };
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).catch(function () { /* hidden inputs still post on a classic submit */ });
  }

  /* ---------- toggle ---------- */

  function setExpanded(expanded) {
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (expanded) {
      panel.hidden = false;
      root.classList.add('b2b-einvoice--open');
      if (toggleIcon) toggleIcon.textContent = '−'; /* minus */
    } else {
      panel.hidden = true;
      root.classList.remove('b2b-einvoice--open');
      if (toggleIcon) toggleIcon.textContent = '+';
    }
  }

  toggle.addEventListener('click', function () {
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    setExpanded(!expanded);
  });

  /* ---------- fill company fields ---------- */

  function fillCompany(data) {
    /* identity payload: denomination, siren, tva_intracommunautaire (verbatim) */
    var name = data && data.denomination ? String(data.denomination) : '';
    var siren = data && data.siren ? String(data.siren) : '';
    var tva = data && data.tva_intracommunautaire ? String(data.tva_intracommunautaire) : '';

    if (name) {
      attrName.value = name;
      nameInput.value = name;
    }
    if (siren) {
      attrSiren.value = siren;
    }
    if (tva) {
      tvaInput.value = tva;
      attrTva.value = tva;
      if (TVA_RE.test(tva)) {
        setHint(tvaHint, 'TVA valide', 'ok');
      } else {
        setHint(tvaHint, '', null);
      }
    }
    persistAttributes();
  }

  /* ---------- PDP auto-trigger ---------- */

  function clearPdp() {
    pdpStatus.hidden = true;
    pdpStatus.textContent = '';
    pdpStatus.className = 'b2b-einvoice__pdp';
    attrRegistered.value = '';
    attrEndpoint.value = '';
  }

  function renderPdp(data) {
    var found = data && data.found === true;
    var isActive = data && data.is_active === true;
    var endpoint = data && data.electronic_address ? String(data.electronic_address) : '';
    var registered = found && isActive && !!endpoint;

    pdpStatus.hidden = false;
    pdpStatus.className = 'b2b-einvoice__pdp';

    if (registered) {
      pdpStatus.classList.add('b2b-einvoice__pdp--registered');
      pdpStatus.textContent = 'Entreprise enregistrée — facture livrée électroniquement (PDP)';
      attrRegistered.value = 'true';
      attrEndpoint.value = endpoint;
    } else {
      pdpStatus.classList.add('b2b-einvoice__pdp--standard');
      var msg = 'Non enregistrée — facturation classique';
      if (found && !isActive) {
        msg = 'Non enregistrée (compte inactif) — facturation classique';
      }
      pdpStatus.textContent = msg;
      attrRegistered.value = 'false';
      attrEndpoint.value = '';
    }
    persistAttributes();
  }

  function triggerPdp(siren) {
    if (!SIREN_RE.test(siren)) return;
    pdpStatus.hidden = false;
    pdpStatus.className = 'b2b-einvoice__pdp b2b-einvoice__pdp--loading';
    pdpStatus.textContent = 'Vérification PDP en cours...';

    fetchJson(B2B_API_BASE + '/api/einvoice/identity/' + encodeURIComponent(siren) + '/pdp-route')
      .then(function (data) {
        renderPdp(data);
      })
      .catch(function () {
        pdpStatus.hidden = false;
        pdpStatus.className = 'b2b-einvoice__pdp b2b-einvoice__pdp--standard';
        pdpStatus.textContent = 'Statut PDP indisponible — facturation classique';
        attrRegistered.value = 'false';
        attrEndpoint.value = '';
        persistAttributes();
      });
  }

  /* ---------- identity by siren (shared) ---------- */

  function loadIdentity(siren, onDone) {
    fetchJson(B2B_API_BASE + '/api/einvoice/identity/' + encodeURIComponent(siren))
      .then(function (data) {
        fillCompany(data);
        triggerPdp(siren);
        if (typeof onDone === 'function') onDone(true);
      })
      .catch(function (err) {
        if (err && err.status === 404) {
          setHint(sirenHint, 'SIREN introuvable.', 'err');
        } else {
          setHint(sirenHint, 'Service indisponible, réessayez.', 'err');
        }
        if (typeof onDone === 'function') onDone(false);
      });
  }

  /* ---------- SIREN exact ---------- */

  function handleSiren() {
    var raw = digitsOnly(sirenInput.value);
    if (raw.length === 0) {
      setHint(sirenHint, '', null);
      return;
    }
    if (raw.length !== 9) {
      setHint(sirenHint, 'Le SIREN doit comporter 9 chiffres.', 'err');
      return;
    }
    setHint(sirenHint, 'Recherche...', null);
    attrSiren.value = raw;
    clearPdp();
    loadIdentity(raw, function (ok) {
      if (ok) setHint(sirenHint, '', null);
    });
  }

  sirenInput.addEventListener('blur', handleSiren);
  sirenInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSiren();
    }
  });

  /* ---------- company-name fuzzy ---------- */

  var debounceTimer = null;

  function clearResults() {
    resultsList.innerHTML = '';
    resultsList.hidden = true;
  }

  function renderResults(hits) {
    resultsList.innerHTML = '';
    if (!hits || !hits.length) {
      clearResults();
      setHint(nameHint, 'Aucun résultat.', null);
      return;
    }
    setHint(nameHint, '', null);
    for (var i = 0; i < hits.length && i < 8; i++) {
      var hit = hits[i] || {};
      var hname = hit.name ? String(hit.name) : '';
      var hsiren = hit.siren ? String(hit.siren) : '';
      var hcity = hit.address && hit.address.city ? String(hit.address.city) : '';

      var li = document.createElement('li');
      li.className = 'b2b-einvoice__result';
      li.setAttribute('role', 'option');
      li.setAttribute('tabindex', '0');
      li.setAttribute('data-b2b-siren', hsiren);

      var elName = document.createElement('span');
      elName.className = 'b2b-einvoice__result-name';
      elName.textContent = hname || '(sans nom)';
      li.appendChild(elName);

      var meta = document.createElement('span');
      meta.className = 'b2b-einvoice__result-meta';
      var metaText = hsiren;
      if (hcity) metaText += metaText ? ' · ' + hcity : hcity;
      meta.textContent = metaText;
      li.appendChild(meta);

      resultsList.appendChild(li);
    }
    resultsList.hidden = false;
  }

  function chooseHit(siren) {
    if (!SIREN_RE.test(siren)) return;
    clearResults();
    sirenInput.value = siren;
    attrSiren.value = siren;
    clearPdp();
    setHint(nameHint, 'Chargement...', null);
    loadIdentity(siren, function (ok) {
      setHint(nameHint, ok ? '' : 'Service indisponible, réessayez.', ok ? null : 'err');
    });
  }

  resultsList.addEventListener('click', function (e) {
    var li = e.target.closest('.b2b-einvoice__result');
    if (li) chooseHit(li.getAttribute('data-b2b-siren'));
  });
  resultsList.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      var li = e.target.closest('.b2b-einvoice__result');
      if (li) {
        e.preventDefault();
        chooseHit(li.getAttribute('data-b2b-siren'));
      }
    }
  });

  function runSearch(q) {
    fetchJson(B2B_API_BASE + '/api/einvoice/company/search?q=' + encodeURIComponent(q))
      .then(function (data) {
        var hits = data && data.hits ? data.hits : [];
        renderResults(hits);
      })
      .catch(function () {
        clearResults();
        setHint(nameHint, 'Recherche indisponible, réessayez.', 'err');
      });
  }

  nameInput.addEventListener('input', function () {
    var q = (nameInput.value || '').trim();
    if (debounceTimer) clearTimeout(debounceTimer);
    if (q.length < 3) {
      clearResults();
      setHint(nameHint, '', null);
      return;
    }
    setHint(nameHint, 'Recherche...', null);
    debounceTimer = setTimeout(function () {
      runSearch(q);
    }, 350);
  });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) clearResults();
  });

  /* ---------- TVA field ---------- */

  tvaInput.addEventListener('blur', function () {
    var norm = (tvaInput.value || '').replace(/\s+/g, '').trim().toUpperCase();
    tvaInput.value = norm;
    if (norm.length === 0) {
      setHint(tvaHint, '', null);
      attrTva.value = '';
      persistAttributes();
      return;
    }
    if (TVA_RE.test(norm)) {
      setHint(tvaHint, 'TVA valide', 'ok');
      attrTva.value = norm;
    } else {
      setHint(tvaHint, 'Format de TVA invalide (ex. FR12345678901).', 'err');
      attrTva.value = norm;
    }
    persistAttributes();
  });
})();
